// Construye la agenda de "hoy" mezclando sesiones de entrenamiento y juegos.
// Puro: sin React ni red.
const horaSort = (a, b) => {
  if (!a.hora && !b.hora) return 0
  if (!a.hora) return 1
  if (!b.hora) return -1
  return a.hora < b.hora ? -1 : a.hora > b.hora ? 1 : 0
}

export const buildAgendaHoy = ({
  sesiones = [], juegos = [], gruposById = {}, sesionCounts = {}, juegoCounts = {},
} = {}) => {
  const items = []

  sesiones
    .filter((s) => s.estatus !== 'cancelado')
    .forEach((s) => {
      const count = sesionCounts[s.id] || 0
      items.push({
        tipo: 'entrenamiento',
        id: s.id,
        grupo_id: s.grupo_id,
        grupo_nombre: gruposById[s.grupo_id] || 'Grupo',
        hora: s.hora_inicio || null,
        titulo: s.titulo || 'Entrenamiento',
        estatus: s.estatus || null,
        asistencia_count: count,
        asistencia_tomada: count > 0,
      })
    })

  juegos
    .filter((j) => j.estatus !== 'cancelado')
    .forEach((j) => {
      const count = juegoCounts[j.id] || 0
      items.push({
        tipo: 'juego',
        id: j.id,
        grupo_id: j.grupo_id,
        grupo_nombre: gruposById[j.grupo_id] || 'Grupo',
        hora: j.hora || null,
        titulo: j.equipo_nombre ? `vs ${j.equipo_nombre}` : (j.torneo?.nombre || 'Juego'),
        estatus: j.estatus || null,
        asistencia_count: count,
        asistencia_tomada: count > 0,
      })
    })

  return items.sort(horaSort)
}
